import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a1bf35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-form" }
const _hoisted_2 = { class: "error text-danger mb-3" }
const _hoisted_3 = { class: "error text-danger mb-3" }
const _hoisted_4 = { class: "error text-danger mb-3" }
const _hoisted_5 = { class: "error text-danger mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signup-form__note" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" By signing up, you confirm that you've read and accepted our "),
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Terms of Service"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, " Privacy Policy. ")
  ])
], -1))
const _hoisted_7 = { class: "d-grid d-block mb-3" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, { onSubmit: _ctx.handleSignUp }, {
      default: _withCtx(({ meta: { valid }, errors }) => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.name) = $event)),
          class: "form-control mb-1",
          rules: "required",
          type: "text",
          name: "name",
          placeholder: "Enter full name"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(errors['name']), 1),
        _createVNode(_component_Field, {
          modelValue: _ctx.user.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.email) = $event)),
          rules: "required|email",
          class: "form-control mb-1",
          type: "email",
          name: "email",
          placeholder: "Enter email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(errors['email']), 1),
        _createVNode(_component_Field, {
          modelValue: _ctx.user.password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.password) = $event)),
          class: "form-control mb-1",
          type: "password",
          name: "password",
          rules: "required",
          placeholder: "Enter password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(errors['password']), 1),
        _createVNode(_component_Field, {
          modelValue: _ctx.user.confirmPassword,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.confirmPassword) = $event)),
          class: "form-control mb-1",
          type: "password",
          rules: "required",
          name: "confirmPassword",
          placeholder: "Re-enter password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(errors['confirmPassword']), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-success btn-sm text-white",
            disabled: !valid
          }, "Continue", 8, _hoisted_8)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}